module.exports = __webpack_public_path__ + "static/media/ui-design.90116edc.svg";